import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DATE_TIME_FORMATS, getFormattedDateTime } from '@tekion/tekion-base/utils/dateUtils';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Content from '../../../atoms/Content';
import styles from './timeStamp.module.scss';
import { TIME_STAMP_SEPARATOR, VIEW_TYPE_TO_TIME_STAMP_COLOR } from './timeStamp.constants';
var TimeStamp = /*#__PURE__*/function (_Component) {
  _inherits(TimeStamp, _Component);
  var _super = _createSuper(TimeStamp);
  function TimeStamp() {
    var _this;
    _classCallCheck(this, TimeStamp);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderTimeStampSeparator", function (timeStampColor) {
      return /*#__PURE__*/React.createElement(Content, {
        className: styles.separator,
        style: {
          color: timeStampColor
        }
      }, TIME_STAMP_SEPARATOR);
    });
    return _this;
  }
  _createClass(TimeStamp, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        containerClassName = _this$props.containerClassName,
        date = _this$props.date,
        view = _this$props.view;
      var formattedDate = getFormattedDateTime(date, DATE_TIME_FORMATS.DATE_ALPHA_MONTH);
      var time = getFormattedDateTime(date, DATE_TIME_FORMATS.HOUR_MIN);
      var timeStampColor = VIEW_TYPE_TO_TIME_STAMP_COLOR[view];
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(containerClassName, " flex align-items-center")
      }, this.renderTimeStampSeparator(timeStampColor), /*#__PURE__*/React.createElement(Content, {
        style: {
          color: timeStampColor
        }
      }, formattedDate), this.renderTimeStampSeparator(timeStampColor), /*#__PURE__*/React.createElement(Content, {
        style: {
          color: timeStampColor
        }
      }, time));
    }
  }]);
  return TimeStamp;
}(Component);
TimeStamp.propTypes = {
  containerClassName: PropTypes.string,
  date: PropTypes.string,
  view: PropTypes.string.isRequired
};
TimeStamp.defaultProps = {
  containerClassName: EMPTY_STRING,
  date: EMPTY_STRING
};
export default TimeStamp;